import { IPlanContent } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  ongoingKeyDetails,
  defaultEstimatesDialog,
  gasKeyDetailsAddons,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

export const originAffinityVariableOngoingContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Affinity Variable Ongoing']),
  content: {
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
        electricity: ongoingKeyDetails,
        gas: ongoingKeyDetails,
        dual: ongoingKeyDetails,
      },
    },
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing contract',
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {},
    estimatesDialog: defaultEstimatesDialog({ customerType: 'residential' }),
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-affinity-variable-ongoing/',
      },
    },
  },
};
